import styled from 'styled-components'
import { Flex, Box } from '../../ui/Layout'
import Button from '../../ui/Button'
import { Text } from '../../ui/Typography'
import { useFormConfig } from '../../context/FormConfigContext'
import Image from '../../ui/Image'

export const Container = styled(Flex)`
  position: relative;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  background: #fff;
  margin-top: 40px;
  margin-bottom: 40px;
  height: calc(100vh - 80px);
  overflow-y: scroll;

  @media (max-width: 700px) {
    height: auto;
    border-radius: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`

const Intro = ({ onNext }) => {
  const { formConfig } = useFormConfig()
  return (
    <Container>
      {formConfig.logoUrl && (
        <Box mb="24px">
          <Image height="40px" src={formConfig.logoUrl} alt="Logo" />
        </Box>
      )}
      <Text light whiteSpace="pre-wrap" mb="24px">
        {formConfig.intro}
      </Text>
      <Button
        backgroundColor={formConfig.buttonColor}
        minHeight="48px"
        mb="24px"
        large
        label="Get Started"
        variant="black"
        fullWidth
        onClick={onNext}
      />
      <Flex justifyContent="flex-end" alignItems="center" position="absolute" bottom="24px" right="24px" width="auto">
        <Flex
          width="auto"
          boxShadow="0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);"
          alignItems="center"
          height="28px"
          px="16px"
          borderRadius="8px"
        >
          <Text fontSize="10px" my="0px" mr="10px" lineHeight="normal">
            Powered by
          </Text>
          <Box as="img" src="/logo.svg" alt="Clipara" height="13px" />
        </Flex>
      </Flex>
    </Container>
  )
}

export default Intro
